import styled from "styled-components";

export const Container = styled.div`
  width: 828px;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 30px 0 20px;
  ${(props) => props.theme.smartphone} {
    padding: 10px 0 10px;
    margin: 0 5%;
  }
  border-radius: 10px;

  & > h1 {
    margin: 30px 0;
    color: ${({ theme }) => theme.brightTurquoise};
    ${(props) => props.theme.smartphone} {
      font-size: 26px;
      margin-top: 15px;
    }
  }
  & > p {
    font-size: 23px;
    line-height: 32px;
    margin-bottom: 40px;
    width: 60%;
    ${(props) => props.theme.smartphone} {
      font-size: 16px;
      line-height: 23px;
      width: 78%;
      margin-bottom: 40px;
    }
  }

  & button:nth-child(4) {
    width: 215px;
    height: 49px;
    font-weight: bold;
    cursor: pointer;
    ${(props) => props.theme.smartphone} {
      width: 150px;
      font-size: 12px;
      height: 35px;
    }
  }
`;

export const CloseButton = styled.button`
  background-color: transparent;
  outline: none;
  border: none;
  cursor: pointer;
  align-self: flex-end;
  margin-right: 30px;
  ${(props) => props.theme.smartphone} {
    margin-right: 10px;
  }
`;

export const Icon = styled.img`
  width: 30px;
  height: 30px;
  ${(props) => props.theme.smartphone} {
    width: 25px;
    height: 25px;
  }
`;
